import $ from 'jquery'
import {Core} from "./core.js";

export class ScrollDown {
  constructor () {
    this.$body = $('body')
    this.$window = $(window)
    this.$button = $('.js-scroll-down')

    this.$button.on('click', this.handleClickScrollDown.bind(this))
  }

  handleClickScrollDown (e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let sectionId = $item.data('section-id')
    let $nextSection = ''

    if (sectionId) {
      $nextSection = $(`#${sectionId}`)

      if ($nextSection.length) {
        Core.scrollTo($nextSection, 500)
        return
      }
    }

    $nextSection = $item.closest('section').next('section')

    Core.scrollTo($nextSection, 500)
  }
}
